import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomCalendar from "../../CustomControls/CustomDatePicker";

const DueDateModal = ({ show, onClose, onNext }) => {
  const [dueDate, setDueDate] = useState(null); // Start as null, not new Date()
  const [error, setError] = useState("");
  if (!show) return null;
  const handleNext = () => {
    if (!dueDate) {
      setError("Due date is required.");
      return;
    }
    setError("");
    onNext(dueDate);
  };
  return (
    <div className="modal show custom-modalld" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    
                    <button type="button" className="btn-close" onClick={onClose}></button>
                </div>
                <div className="modal-body text-center">
                    <h5 style={{fontSize:"1.5rem"}}>When is your due date? Knowing your due date helps us tailor support and resources just for you.</h5>
                    <CustomCalendar
                        selectedDate={dueDate}
                        onChange={date => { setDueDate(date); setError(""); }}
                    />
                    {error && <div className="text-danger small mt-2">{error}</div>}
                    <div className="mt-3">
                        <button className="win-btn-primary mobile-view" onClick={handleNext}>
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
};

export default DueDateModal;
